// extracted by mini-css-extract-plugin
export default {"root":"Header_root__akzOh","title":"Header_title__Zbu1z"};